import axios from "axios";

// Production override: if the page is loaded on a custom domain we own
// (e.g. aura.wwwwhynot.com), call the backend on that same origin so the
// session_token cookie stays first-party. Otherwise fall back to the
// build-time REACT_APP_BACKEND_URL (used by preview + earlier deploys).
const KNOWN_PROD_HOSTS = ["aura.wwwwhynot.com"];

function resolveBackendUrl() {
  try {
    if (typeof window !== "undefined" && window.location && window.location.hostname) {
      if (KNOWN_PROD_HOSTS.includes(window.location.hostname)) {
        return window.location.origin;
      }
    }
  } catch (_) { /* no-op */ }
  return process.env.REACT_APP_BACKEND_URL;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

// Configure axios to send cookies
axios.defaults.withCredentials = true;

export default axios;
